import { Component, OnInit, ErrorHandler } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-coutr-proceeding-form',
  templateUrl: './coutr-proceeding-form.component.html',
  styleUrls: ['./coutr-proceeding-form.component.css']
})
export class CoutrProceedingFormComponent implements OnInit {

  title ="Court Proceedings";  
  Fir_id: any;
  Court_Proc_Id: any;
  CourtDocDetails: any = {};
  FirDetails: any = {};
  CourtProc: any = {};
  CourtDoc: any = {};
  fileToUpload: File = null;
  formSubmitted: boolean;
  formInvalid: boolean;
  data: any;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.formSubmitted = false;
  }

  ngOnInit() {
    this.route.params.subscribe(params =>
      this.Fir_id= params['Fir_id'],
      // this.Court_Proc_Id = params['Court_Proc_Id'],
      // this.Court_Proc_Id = params['Court_Proc_Id'],
       
    );
    if (this.Fir_id != null)
      this.GetFirForTheIdCp(this.Fir_id);
      // if(this.Court_Proc_Id > 0){
      //   this.GetByIdCourtDoc(this.Court_Proc_Id);
      // }
  }

  GetFirForTheIdCp(Fir_id) {
    debugger;
     
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetFirForTheIdCp(Fir_id)
    
      .subscribe(
        (data: any) => {
          this.FirDetails = data;
          this.CourtDocDetails=data.CourtProceedingModels.CourtProceedingDocumentModels;
          this.CourtProc=data.CourtProceedingModels;

          if (this.CourtProc.Court_Proc_Date != null)
            this.CourtProc.Court_Proc_Date = ((this.CourtProc.Court_Proc_Date).split('T'))[0];
          console.log(data);
          console.log(this.CourtDocDetails);

          // this.GetByIdCourtDoc(this.FirDetails.Court_Proc_Id)
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });
       
  }

  

  //Update

  UpdateCourtProceeding(Court_Proc_Id,CourtProceeding: NgForm) {
    debugger;
    
    CourtProceeding.value.Fir_id = this.Fir_id;
    CourtProceeding.value.Court_Proc_FilePath = this.getFeasibilitySignFUrl();
    this.data = this.userService.UpdateCourtProceeding(CourtProceeding.value, Court_Proc_Id);
    this.data.subscribe(
      (response) => {
        CourtProceeding.reset();
        CourtProceeding.resetForm();
        CourtProceeding.form.markAsPristine();
        CourtProceeding.form.markAsUntouched();

        swal('Success!', 'CourtProceeding updated Successfully .', 'success');
        document.getElementById('loader-spinner').style.display = "none";
        this.router.navigate(['/home/court-proceedings']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });

  }
 
//adding document details

  // onAddDoc(Court_Proc_Id) 
  // {
    
  //   this.data = this.userService.PostCourtDoc(this.Court_Proc_Id);
  //   this.data.subscribe(
  //     (response) => {       
  //       swal('Success!', 'Documents Added Successfully .', 'success');       
  //       document.getElementById('loader-spinner').style.display = "none";
  //     })
  //     }


//adding Documents details

  onSubmit(Court_Proc_Id: any, form: NgForm) {
    // this.CourtProc.Court_Proc_Id=this.Court_Proc_Id;
    debugger
    if (!form.invalid) {
      document.getElementById('loader-spinner').style.display = "block";
      form.value.CourtProc_Doc_FilePath = this.getFeasibilityDocBriefFUrl();
      this.userService.PostCourtDoc(Court_Proc_Id, form.value)
        .subscribe(
          (data) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.GetFirForTheIdCp(this.Fir_id)
            form.reset();
            form.resetForm();
            this.formSubmitted = false;
            swal('', 'Saved Successfully!', 'success');
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.handleError(error);
          });
    } else
      document.getElementById('loader-spinner').style.display = "none";
    this.formSubmitted = true;
  }

  
  //upload file paths
  imageUpload1(file: FileList) {
    debugger;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        //  this.IS_UploadPath = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage1(data);
      x.subscribe(
        (response) => {

        }, (error) => {
          let i: any = document.getElementById('CourtProc_Doc_FilePath');
          i.value = "";
          if (error.status == 400) {
            //this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('CourtProc_Doc_FilePath');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getFeasibilityDocBriefFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('CourtProc_Doc_FilePath');
      console.log('CourtDoc file');
      console.log(imagename.files[0].name);
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  //upload2

  imageUpload2(file: FileList) {
    debugger;
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;

    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        //  this.IS_UploadPath = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage2(data);
      x.subscribe(
        (response) => {

        }, (error) => {
          let i: any = document.getElementById('Court_Proc_FilePath');
          i.value = "";
          if (error.status == 400) {
            //this.FeasibilityPDFUrl = "assets/images/image-default.png";
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('Court_Proc_FilePath');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }



  getFeasibilitySignFUrl() {
    let imagename = null;
    try {
      imagename = document.getElementById('Court_Proc_FilePath');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  Cancel(){
    this.CourtProc.Court_Proc_Note = '';
    this.CourtProc.Court_Proc_Date = '';
    this.CourtProc.Court_Proc_FilePath = '';
    this.CourtProc.Court_Proc_Status = '';
    // this.CourtProc.Fir_Date = '';
  }

  


  delete(CourtProc_Doc_Id){
    debugger;
    swal({
         title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
        this.data = this.userService.DeleteCourtDoc(CourtProc_Doc_Id);
        this.data.subscribe(
         (response: any) => {
        this.GetFirForTheIdCp(this.Fir_id);
         },(error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        }       
      ); 
    } 
    })
    }


}



// WEBPACK FOOTER //
// ./src/app/court-proceedings/court-proceeding/coutr-proceeding-form/coutr-proceeding-form.component.ts